export const queryKey = {
  alarmSettings: () => ['alarmSettings'],
  beautyInfo: () => ['beautyInfo'],
  marketingAlarmSettings: () => ['marketingAlarmSettings'],
  pocList: () => ['pocList'],
  productCategories: () => ['productCategories'],
  productCategoryMeasureValues: (productCategorySno?: number) => [
    'productCategoryMeasureValues',
    productCategorySno,
  ],
};
